// Recovered compiled webpack factory 27122. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  r.d(t, {
    Cp: () => l,
    J0: () => h,
    J5: () => g,
    Ol: () => d,
    SA: () => p,
    o: () => f,
    r: () => c,
    wd: () => u,
  });
  var n = r(2257),
    a = r(24617),
    o = r(71350),
    i = r(3055),
    s = r(49636);
  function l(e, t) {
    return (0, n.o5)().captureException(e, (0, o.li)(t));
  }
  function u(e, t) {
    let r = "string" == typeof t ? t : void 0,
      a = "string" != typeof t ? { captureContext: t } : void 0;
    return (0, n.o5)().captureMessage(e, r, a);
  }
  function c(e, t) {
    return (0, n.o5)().captureEvent(e, t);
  }
  function f(e, t) {
    (0, n.rm)().setContext(e, t);
  }
  function d() {
    let e = (0, n.KU)();
    return e?.getOptions().enabled !== !1 && !!e?.getTransport();
  }
  function p(e) {
    (0, n.rm)().addEventProcessor(e);
  }
  function h(e) {
    let t = (0, n.rm)(),
      { user: r } = (0, i.Om)(t, (0, n.o5)()),
      { userAgent: o } = s.O.navigator || {},
      l = (0, a.fj)({ user: r, ...(o && { userAgent: o }), ...e }),
      u = t.getSession();
    return (u?.status === "ok" && (0, a.qO)(u, { status: "exited" }), _(), t.setSession(l), l);
  }
  function _() {
    let e = (0, n.rm)(),
      t = (0, n.o5)().getSession() || e.getSession();
    (t && (0, a.Vu)(t), m(), e.setSession());
  }
  function m() {
    let e = (0, n.rm)(),
      t = (0, n.KU)(),
      r = e.getSession();
    r && t && t.captureSession(r);
  }
  function g(e = !1) {
    if (e) return void _();
    m();
  }
}
